import React from 'react'
import { H5 } from '../headings/index'
import { FooterWrapper, FooterGrid, FooterSmallGridWrapper, FooterSmallGrid } from './style'
import Container from '../container/index'
import globals from '../globals'
import { ReactComponent as LogoSeguro } from '../../images/logo-fundo-branco.svg'

import IconFacebook from '../../images/logos/facebook-f.svg'
import IconLinkedin from '../../images/logos/linkedin-in.svg'
import IconInstagram from '../../images/logos/instagram-icon.svg'

const Footer = () => {

  const handleAnchor = event => {
    event.preventDefault()
    const id = event.currentTarget.getAttribute('href').replace('#', '')
    const target = document.getElementById( id )

    if(target){
      target.scrollIntoView({behavior: 'smooth'})
    }
  }

  return (
    <FooterWrapper>

      <Container>
        <FooterGrid>
          <div className="about">
            <LogoSeguro width="155" />
            <p>O Seguro Residencial da CredPago é um produto distribuído pela 180 Seguros S.A., CNPJ: 39.999.619/0001-97, em parceria com a representante de seguros CredPago Serviços de Cobrança S/A, CNPJ: 25.027.928/0001-90 para levar mais segurança aos imóveis alugados. Com esse seguro, o imóvel está protegido de acordo com a cobertura escolhida no momento da contratação. Processo Susep nº 15414.618369 2023-83. O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep. A aceitação do seguro estará sujeita à análise do risco. O segurado poderá consultar a situação cadastral do corretor de seguros e da sociedade seguradora no sítio eletrônico www.susep.gov.br ou através do número 0800 021 8484, por meio de seu registro na Susep, nome completo e CNPJ ou CPF. Consulte as Condições Gerais disponíveis em <a href='https://www.180s.com.br/'>www.180s.com.br</a>.</p>
          </div>
          <div>
            <H5 style={{marginTop: "28px", color: "#113c64"}} weight={'bold'} font={"Uni neue"} fontStyle={"18px"} >FALAR COM A 180º</H5>
            <ul >
              <li style={{fontSize: "12px", fontFamily: "Roboto", lineHeight: "16px", maxWidth: "200px", margin: "16px 0", color: "#113c64"}}>Caso precise abrir um sinistro 
ou acionar um serviço 
de assistência, ligue para:
</li>
              <li style={{fontSize: "16px", fontFamily: "Roboto", fontWeight: "bold", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>0800 888 1018</li>
              <li style={{fontSize: "12px", fontFamily: "Roboto", fontWeight: "regular", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>
                Ligação e WhatsApp
              </li>
              <li style={{fontSize: "12px", fontFamily: "Roboto", fontWeight: "regular", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>
                De segunda a sexta, das 8h às 19h
                <br />
                ou sábado das 8h às 15h.
              </li>
              <li style={{fontSize: "12px", fontFamily: "Roboto", fontWeight: "regular", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>
              Para atendimento fora do horário  <br />
              você será encaminhado  <br />
              para central 24hs
              </li>




            </ul>
          </div>
          <div id="contato">
          <H5 style={{marginTop: "28px", color: "#113c64"}} weight={'bold'} font={"Uni neue"} fontStyle={"18px"} >FALAR COM A CREDPAGO</H5>
            <ul>
              <li style={{fontSize: "12px", fontFamily: "Roboto", fontWeight: "regular", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>atendimento@credpago.com</li>
              <li style={{fontSize: "16px", fontFamily: "Roboto", fontWeight: "bold", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>0800 001 6002</li>
              <li style={{fontSize: "12px", fontFamily: "Roboto", fontWeight: "regular", lineHeight: "16px", maxWidth: "200px", color: "#113c64"}}>
              Atendimento de Segunda a <br /> Sexta-feira  <br />
              das 9h00 às 19h00 e aos <br />
              Sábados das 9h00 às 13h00 <br />
              (exceto feriados nacionais)<br />
              </li>
            </ul>
          </div>
        </FooterGrid>
      </Container>
      <FooterSmallGridWrapper>
        <FooterSmallGrid>
          <p>© {new Date().getFullYear()} CredPago - Todos os direitos reservados</p>
          <nav>
            <ul>
              <li>
                <a href="//instagram.com/credpago" target="_blank" rel="noreferrer">
                  <img src={IconInstagram} alt="Instagram" />  
                </a>
              </li>
              <li>
                <a href="//facebook.com/credpago" target="_blank" rel="noreferrer">
                  <img src={IconFacebook} alt="Facebook" />  
                </a>
              </li>
              <li>
                <a href="//www.linkedin.com/company/credpago/" target="_blank" rel="noreferrer">
                  <img src={IconLinkedin} alt="LinkedIn" />
                </a>
              </li>
            </ul>
          </nav>
        </FooterSmallGrid>
      </FooterSmallGridWrapper>
    </FooterWrapper>
  )
}

export default Footer